import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { cn } from '../../lib/cn';

interface CampoPasswordProps {
    etichetta: string;
    valore: string;
    onChange: (valore: string) => void;
    /**
     * Dice al browser e ai gestori di password cosa c'e' nella casella:
     * 'current-password' la riempiono con quella salvata, 'new-password'
     * propongono di generarne una e poi aggiornano quella salvata.
     */
    completamento: 'current-password' | 'new-password';
    disabilitato?: boolean;
    autoFocus?: boolean;
    conErrore?: boolean;
}

/** Casella per una password, con l'occhio per vedere cosa si sta scrivendo. */
export function CampoPassword({
    etichetta,
    valore,
    onChange,
    completamento,
    disabilitato,
    autoFocus,
    conErrore
}: CampoPasswordProps) {
    const id = React.useId();
    const [visibile, setVisibile] = useState(false);

    return (
        <div className="space-y-1.5">
            <Label htmlFor={id} className="text-sm font-medium text-gray-700">
                {etichetta}
            </Label>
            <div className="relative">
                <Input
                    id={id}
                    type={visibile ? 'text' : 'password'}
                    value={valore}
                    autoComplete={completamento}
                    autoFocus={autoFocus}
                    disabled={disabilitato}
                    onChange={(e) => onChange(e.target.value)}
                    aria-invalid={conErrore || undefined}
                    className={cn('pr-10', conErrore && 'border-red-400 focus-visible:ring-red-400')}
                />
                <button
                    type="button"
                    onClick={() => setVisibile((v) => !v)}
                    disabled={disabilitato}
                    aria-label={visibile ? 'Nascondi password' : 'Mostra password'}
                    className="absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 disabled:opacity-50"
                >
                    {visibile ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
                </button>
            </div>
        </div>
    );
}

export default CampoPassword;
